import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import { MatInputModule } from '@angular/material/input'
import {
  MatDatepicker,
  MatDatepickerModule,
} from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { NgxMaskDirective } from 'ngx-mask'
import moment from 'moment'
import { emailValidator } from '../../../../shared/utils/email_validator'

@Component({
  selector: 'responsible-client-form',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMaskDirective,
  ],
  templateUrl: './responsible-client-form.component.html',
  styleUrl: './responsible-client-form.component.scss',
  providers: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResponsibleClientFormComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
  ) {
    const today = new Date()
    const currentYear = today.getFullYear()
    const currentMonth = today.getMonth()
    const currentDay = today.getDate()
    this.maxDate = new Date(currentYear - 18, currentMonth, currentDay)
  }

  form: FormGroup = new FormGroup({})
  loading: boolean = false

  @Output() response = new EventEmitter()
  @Input() editItem: any = {}
  @ViewChild('birth') datepicker: MatDatepicker<any> | undefined

  listType: any[] = []

  maxDate!: Date

  ngOnInit(): void {
    this.createForm()
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }

  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm()
    }
  }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.idCreate) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  fillForm() {
    this.form.get('name')?.setValue(this.editItem.nome)
    this.form.get('email')?.setValue(this.editItem.email)
    this.form.get('phone')?.setValue(this.editItem.telefone)
  }

  resetForm() {
    this.form.reset()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      phone: ['', [Validators.required, Validators.minLength(10)]],
      email: ['', [Validators.required, emailValidator()]],
    })
  }

  createAddress() {
    this.loading = true
    const model = this.createModel()
    this.response.emit({ action: 'create', item: model })
    this.resetForm()
    this.loading = false
  }

  editAddress() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'edit', item: model })
    this.resetForm()
    this.loading = false
  }

  deleteAddress() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'delete', item: model })
    this.resetForm()
    this.loading = false
  }

  cancel() {
    this.response.emit({ action: 'cancel' })
    this.resetForm()
  }

  createModel(edit: boolean = false) {
    if (edit) {
      return {
        idCreate: this.editItem.idCreate,
        nome: this.form.controls['name'].value,
        email: this.form.controls['email'].value,
        telefone: this.form.controls['phone'].value,
      }
    } else {
      return {
        nome: this.form.controls['name'].value,
        email: this.form.controls['email'].value,
        telefone: this.form.controls['phone'].value,
      }
    }
  }
  openDatepicker() {
    if (this.datepicker) {
      this.datepicker.open()
    }
  }
}
